import Carousel from "primevue/carousel";

export const ScrollableCarousel = {
    extends: Carousel,
    props: {numVisible: Number, numScroll: Number, responsiveOptions: Array,},
    methods: {
        onTouchMove() {
            return
        },
    },
};